const setSize = () => {
	const videoHolder = document.querySelector('.hero-video__holder');
	if (videoHolder) {
		const header = document.querySelector('.header');
		const videoHeading = document.querySelector('.hero-video__heading');
		const videoContainer = document.querySelector('.hero-video');
		if (document.documentElement.clientWidth >= 1280) {
			let videoHolderHeight = document.documentElement.clientHeight
				- header.clientHeight - videoHeading.clientHeight
				- parseInt(getComputedStyle(videoHeading).marginBottom)
				- parseInt(getComputedStyle(videoContainer).paddingTop);
			
			let videoHolderWidth = videoHolderHeight * 1.77;
			if (videoHolderWidth >= document.documentElement.clientWidth - 100) {
				videoHolderWidth = document.documentElement.clientWidth - 100;
				videoHolderHeight = videoHolderWidth / 1.77;
			}
			
			videoHeading.style.width = `${videoHolderWidth}px`;
			videoHolder.style.height = `${videoHolderHeight}px`;
			videoHolder.style.width = `${videoHolderWidth}px`;
			videoContainer.classList.add('hero-video--active');
		} else {
			videoHeading.style.cssText = '';
			videoHolder.style.cssText = '';
		}
	}
};

const setHeroVideoSize = () => {
	setTimeout(() => {
		setSize();
		window.addEventListener('resize', setSize);
	}, 1000);
};

export default setHeroVideoSize;
